<template>
  <v-container>
    <network
      v-if="choosenNetwork!=null && path=='info'"
      :choosenNetwork="choosenNetwork"
      @back="back"
      @edit="editNetwork"
      @error="error"
      @saved="saved"
      @user="editUserInNetwork"
    ></network>
    <edit-net
      v-if="(path=='edit')"
      :choosenNetwork="choosenNetwork"
      :path="path"
      @backinfo="backinfo"
      @error="error"
      @saved="saved"
    ></edit-net>
    <manage-user
      v-if="choosenNetwork!=null && path=='manageUser'"
      :choosenNetwork="choosenNetwork"
      @back="backinfo"
    ></manage-user>
  </v-container>
</template>

<script>
import NetworkComponent from "../Networks/NetworkInfo";
import EditNetworkComponent from "../Networks/EditNetwork";
import ManageUserNetworkComponent from "../Networks/ManageUserInNetwork";

export default {
  components: {
    network: NetworkComponent,
    "edit-net": EditNetworkComponent,
    "manage-user": ManageUserNetworkComponent
  },
  props: {
    choosenNetwork: Object,
    path: String
  },

  methods: {
    back: function() {
      this.$emit("back");
    },
    backinfo: function() {
      this.$emit("backinfo");
    },
    editNetwork: function() {
      this.$emit("edit");
    },
    editUserInNetwork: function() {
      this.$emit("user");
    },
    error: function(value) {
      this.$emit("error", value);
    },
    saved: function(value) {
      this.$emit("saved", value);
    }
  }
};
</script>


